// settings/avatarsettings.jsx
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom"; // 🆕 اضافه شد
import "./AvatarSettings.css";
import { useAuth } from "../../context/AuthContext";      // ← اضافه شد
import { useCoins } from "../../context/CoinContext";
import { engine } from "../../core/books/storage.js";

const DEFAULT_AVATAR = "/avatars/avatar34.png";

const AVATARS = [
  { id: 1, price: 5000, image: "/avatars/avatar1.png" },
  { id: 2, price: 5000, image: "/avatars/avatar2.png" },
  { id: 3, price: 2500, image: "/avatars/avatar3.png" },
  { id: 4, price: 1500, image: "/avatars/avatar4.png" },
  { id: 5, price: 1500, image: "/avatars/avatar5.png" },
  { id: 6, price: 1500, image: "/avatars/avatar6.png" },
  { id: 7, price: 700, image: "/avatars/avatar7.png" },
  { id: 8, price: 700, image: "/avatars/avatar8.png" },
  { id: 9, price: 700, image: "/avatars/avatar9.png" },
  { id: 10, price: 700, image: "/avatars/avatar10.png" },
  { id: 11, price: 500, image: "/avatars/avatar11.png" },
  { id: 12, price: 500, image: "/avatars/avatar12.png" },
  { id: 13, price: 500, image: "/avatars/avatar13.png" },
  { id: 14, price: 500, image: "/avatars/avatar14.png" },
  { id: 15, price: 500, image: "/avatars/avatar15.png" },
  { id: 16, price: 500, image: "/avatars/avatar16.png" },
  { id: 17, price: 500, image: "/avatars/avatar17.png" },
  { id: 18, price: 500, image: "/avatars/avatar18.png" },
  { id: 19, price: 500, image: "/avatars/avatar19.png" },
  { id: 20, price: 300, image: "/avatars/avatar20.png" },
  { id: 21, price: 300, image: "/avatars/avatar21.png" },
  { id: 22, price: 300, image: "/avatars/avatar22.png" },
  { id: 23, price: 300, image: "/avatars/avatar23.png" },
  { id: 24, price: 300, image: "/avatars/avatar24.png" },
  { id: 25, price: 300, image: "/avatars/avatar25.png" },
  { id: 26, price: 300, image: "/avatars/avatar26.png" },
  { id: 27, price: 300, image: "/avatars/avatar27.png" },
  { id: 28, price: 300, image: "/avatars/avatar28.png" },
  { id: 29, price: 300, image: "/avatars/avatar29.png" },
  { id: 30, price: 300, image: "/avatars/avatar30.png" },
  { id: 31, price: 300, image: "/avatars/avatar31.png" },
  { id: 32, price: 300, image: "/avatars/avatar32.png" },
  { id: 33, price: 300, image: "/avatars/avatar33.png" },
  { id: 34, price: 0, image: "/avatars/avatar34.png" },
  ...Array.from({ length: 39 }, (_, i) => ({
    id: i + 37,
    price: 10,
    image: "",
  })),
];


// ✅ جدید: اعتبارسنجی و نرمال‌سازی آواتار
const isValidAvatar = (img) =>
  typeof img === "string" && AVATARS.some((a) => a.image === img);

const normalizeAvatar = (raw) => {
  if (!raw) return null;
  if (isValidAvatar(raw)) return raw;
  const name = String(raw).split("/").pop();
  const byFile = AVATARS.find(
    (a) => a.image && (a.image.endsWith("/" + name) || a.image === name)
  );
  if (byFile) return byFile.image;
  const byId = AVATARS.find((a) => String(a.id) === String(raw));
  return byId?.image || null;
};

const Particles = () => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const newParticles = Array.from({ length: 30 }, () => ({
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 3 + 1,
      duration: Math.random() * 15 + 10,
      delay: Math.random() * 10,
      opacity: Math.random() * 0.3 + 0.1,
    }));
    setParticles(newParticles);
  }, []);

  return (
    <div className="particles-container">
      {particles.map((p, i) => (
        <div
          key={i}
          className="particle"
          style={{
            left: `${p.x}%`,
            top: `${p.y}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            opacity: p.opacity,
          }}
        />
      ))}
    </div>
  );
};

export default function AvatarSettings() {
  // ===== اتصال به Context =====
  const { user, updateUser } = useAuth();
  const { coins: contextCoins, removeCoins } = useCoins();
  const navigate = useNavigate(); // 🆕

  const [activeTab, setActiveTab] = useState("avatars");

  // ===== هماهنگ‌سازی تم با ناوبر =====
const [isDark, setIsDark] = useState(() => {
  try {
    // 🔧 FIX: خواندن از engine
    return engine.getRaw('navbar2-drawer-dark') === '1';
  } catch {
    return false;
  }
});

useEffect(() => {
  // گوش دادن به تغییرات localStorage (وقتی کاربر در ناوبر تم رو عوض می‌کنه)
  const handleStorage = (e) => {
    if (e.key === 'navbar2-drawer-dark') {
      setIsDark(e.newValue === '1');
    }
  };
  window.addEventListener('storage', handleStorage);

  // برای همگام‌سازی در همون تب (storage event فقط در تب‌های دیگه فراخوانی می‌شه)
const interval = setInterval(() => {
  try {
    // 🔧 FIX: خواندن از engine
    const current = engine.getRaw('navbar2-drawer-dark') === '1';
    setIsDark((prev) => (prev !== current ? current : prev));
  } catch {}
}, 500);

  return () => {
    window.removeEventListener('storage', handleStorage);
    clearInterval(interval);
  };
}, []);

const [selectedAvatar, setSelectedAvatar] = useState(
  () => normalizeAvatar(user?.avatar) || DEFAULT_AVATAR
);
  const defaultAppliedRef = useRef(null);
  const [coins, setCoins] = useState(contextCoins ?? user?.coins ?? 0);
const [hoveredId, setHoveredId] = useState(null);
const [selectedId, setSelectedId] = useState(null);

// 🔒 تضمین: همیشه یک URL معتبر برای نمایش
const displayAvatar = normalizeAvatar(selectedAvatar) || DEFAULT_AVATAR;

  // ✅ آواتارهای خریداری‌شده (برای جلوگیری از خرید تکراری)
  //    initializer فقط مقدار حداقلی را می‌دهد — چون user در اولین رندر null است
  const [ownedAvatars, setOwnedAvatars] = useState([1]);

  // ✅ بارگذاری از فیلد ownedAvatars روی کاربر در سرور
  useEffect(() => {
    if (!user?.id) return;
    try {
      // ✅ اول از خود کاربر (که از سرور میاد)
      let parsed = Array.isArray(user.ownedAvatars) ? [...user.ownedAvatars] : [];

      // مایگریشن: آواتار فعلی کاربر رو هم به لیست اضافه کن
      if (parsed.length === 0) {
        parsed = [1];
      }
      if (user?.avatar) {
        const current = AVATARS.find((a) => a.image === user.avatar);
        if (current && !parsed.includes(current.id)) {
          parsed.push(current.id);
        }
      }

      setOwnedAvatars(parsed);

      // اگه تازه ساخته شد یا مایگریت شد، در سرور هم ذخیره کن
      if (!Array.isArray(user.ownedAvatars) || user.ownedAvatars.length !== parsed.length) {
        updateUser({ ownedAvatars: parsed });
      }
    } catch {
      setOwnedAvatars([1]);
    }
  }, [user?.id, user?.avatar, user?.ownedAvatars, updateUser]);

  const availableCount = AVATARS.filter((a) => a.image).length;
  const gridRef = useRef(null);

  // ===== همگام‌سازی با تغییرات کاربر =====
// ===== همگام‌سازی با تغییرات کاربر + ذخیره پیش‌فرض در دیتابیس =====
useEffect(() => {
  if (!user?.id) return;

  // اگه کاربر آواتار معتبر داره، همون رو نشون بده
  const normalized = normalizeAvatar(user.avatar);
  if (normalized) {
    setSelectedAvatar(normalized);
    return;
  }

  // کاربر آواتار معتبر نداره → پیش‌فرض رو اعمال کن
  setSelectedAvatar(DEFAULT_AVATAR);

  if (defaultAppliedRef.current === user.id) return;
  defaultAppliedRef.current = user.id;
  updateUser({ avatar: DEFAULT_AVATAR });
}, [user?.id, user?.avatar, updateUser]);

  useEffect(() => {
    if (contextCoins !== undefined) setCoins(contextCoins);
  }, [contextCoins]);

  // جلوگیری از کلیک راست
  const handleContextMenu = (e) => {
    e.preventDefault();
    return false;
  };

  // جلوگیری از درگ
  const handleDragStart = (e) => {
    e.preventDefault();
    return false;
  };

  // جلوگیری از ذخیره با میانبرها
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "PrintScreen") {
        e.preventDefault();
        alert("📸 اسکرین‌شات در این صفحه غیرفعال است!");
        return false;
      }
      if ((e.ctrlKey || e.metaKey) && e.key === "s") {
        e.preventDefault();
        return false;
      }
      if ((e.ctrlKey || e.metaKey) && e.key === "p") {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleSelectAvatar = (avatar) => {
    if (!avatar.image) return;

    // ✅ آیا کاربر این آواتار رو قبلاً خریده؟
    const alreadyOwned = ownedAvatars.includes(avatar.id);

    // ✅ اگه قبلاً نخریده و سکه کافی نیست → خطا
    if (!alreadyOwned && coins < avatar.price) {
      alert("😅 سکه‌هات برای خرید این آواتار کافی نیست!");
      return;
    }

    // ✅ کم کردن واقعی سکه از Context (فقط برای خرید جدید)
    if (!alreadyOwned && avatar.price > 0 && removeCoins) {
      removeCoins(avatar.price);
    }

    // ✅ ساخت آپدیت‌ها
    const updates = { avatar: avatar.image };

    // ✅ افزودن به لیست خریداری‌شده‌ها (در سرور ذخیره می‌شه)
    if (!alreadyOwned) {
      const updatedOwned = [...ownedAvatars, avatar.id];
      setOwnedAvatars(updatedOwned);
      updates.ownedAvatars = updatedOwned;
    }

    // ✅ اعمال آواتار جدید
    setSelectedAvatar(avatar.image);
    setSelectedId(avatar.id);

if (user) {
  updateUser(updates);

  // ✅ Defense: مستقیم هم localStorage رو سینک کن — برای اطمینان
  try {
    const stored = JSON.parse(localStorage.getItem('user') || '{}');
    localStorage.setItem(
      'user',
      JSON.stringify({ ...stored, ...updates })
    );
  } catch {}
}
  };

const handleGoBack = () => {
  // 🆕 استفاده از React Router به جای window.location برای SPA
  // بررسی می‌کنیم آیا تاریخچه‌ای وجود دارد یا نه (شاخص idx در React Router v6)
  const historyIdx = window.history.state?.idx ?? 0;
  
  if (historyIdx > 0) {
    // اگر از صفحه‌ای دیگر آمده‌ایم (از طریق دکمه‌های داخل اپ)، به عقب برگرد
    navigate(-1);
  } else {
    // اگر کاربر مستقیماً وارد این صفحه شده (بدون تاریخچه)، بر اساس نقش هدایت شود
    const roleRoutes = {
      student: '/StudentHome',
      teacher: '/TeacherHome',
      parent:  '/ParentHome',
      admin:   '/AdminHome',
    };
    const target = roleRoutes[user?.role] || '/';
    navigate(target, { replace: true });
  }
};

return (
  <div
    className={`avatar-page ${isDark ? 'dark-mode' : ''}`}
    onContextMenu={handleContextMenu}
  >
      <Particles />

      <header className="avatar-header">
        <div className="header-left">
          <div className="logo-ring">
            <span>✦</span>
          </div>
          <span className="logo-text">آواتارا</span>
        </div>
        <div className="header-right">
          <div className="stat-pill">
            <span className="stat-num">{availableCount}</span>
            <span className="stat-label">آواتار</span>
          </div>
          <div className="coin-pill">
            <img src="/coin-1.svg" alt="coin" />
            <span>{coins}</span>
          </div>
          <button className="back-btn" onClick={handleGoBack} title="بازگشت">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M19 12H5" />
              <path d="M12 19l-7-7 7-7" />
            </svg>
            <span className="back-label">بازگشت</span>
          </button>
        </div>
      </header>

      <div className="avatar-content">

        <section className="hero-section">
          <div className="hero-avatar-wrapper">
            <div className="hero-ring">
              <div className="hero-ring-orbit" />
              <div className="hero-ring-orbit second" />
              <div className="hero-ring-orbit third" />
              <div className="hero-ring-orbit fourth" />
              <div className="hero-avatar">
                <img src={displayAvatar} alt="آواتار فعلی" />
                <div className="hero-avatar-shine" />
                <div className="hero-avatar-pulse" />
                <div className="hero-protect-overlay">
                  <span className="hero-protect-text">✦ آواتارا ✦</span>
                </div>
              </div>
            </div>
          </div>
          <div className="hero-text">
            <h1 className="hero-title">
              <span className="gradient-text">آواتار</span> خودت رو انتخاب کن
            </h1>
            <p className="hero-desc">
              یک هویت جدید بساز <span className="hero-dot">●</span>{" "}
              {availableCount} آواتار ویژه
            </p>
            <div className="hero-badge">
              <span className="badge-spark">✦</span> جدیدترین‌ها
            </div>
          </div>
        </section>

        <div className="tabs-modern">
          <button
            className={`tab-modern ${activeTab === "avatars" ? "active" : ""}`}
            onClick={() => setActiveTab("avatars")}
          >
            <span className="tab-icon">🎭</span>
            <span className="tab-label">گالری</span>
          </button>
          <button
            className={`tab-modern ${activeTab === "ai" ? "active" : ""}`}
            onClick={() => setActiveTab("ai")}
          >
            <span className="tab-icon">✨</span>
            <span className="tab-label">هوش مصنوعی</span>
          </button>
        </div>

        <div className="tab-content-wrapper">
          {activeTab === "avatars" && (
            <div
              className="avatar-grid-modern"
              ref={gridRef}
              onDragStart={handleDragStart}
            >
              {AVATARS.map((avatar, index) => {
                const isOwned = ownedAvatars.includes(avatar.id);
                const isCurrent = displayAvatar === avatar.image;

                return (
                  <div
                    key={avatar.id}
                    className={`avatar-card-modern ${!avatar.image ? "locked" : ""} ${
                      hoveredId === avatar.id ? "hovered" : ""
                    } ${isCurrent ? "selected" : ""} ${
                      isOwned ? "owned" : ""
                    }`}
                    onClick={() => handleSelectAvatar(avatar)}
                    onMouseEnter={() => setHoveredId(avatar.id)}
                    onMouseLeave={() => setHoveredId(null)}
                    style={{ animationDelay: `${(index % 24) * 20}ms` }}
                  >
                    <div className="card-modern-image">
                      {avatar.image ? (
                        <>
                          <img src={avatar.image} alt={`آواتار ${avatar.id}`} />
                          {/* لایه شیشه‌ای نیمه‌شفاف + قیمت */}
                          <div className="glass-overlay">
                            <div className="glass-price">
                              <img src="/coin-1.svg" alt="coin" />
                              <span>{isOwned ? "✓" : avatar.price}</span>
                            </div>
                            <span className="glass-watermark">✦</span>
                          </div>
                          {/* لایه شفاف برای جلوگیری از کلیک راست */}
                          <div className="image-protect-layer" />
                        </>
                      ) : (
                        <div className="card-locked-state">
                          <span className="lock-id">{avatar.id}</span>
                          <span className="lock-icon">🔒</span>
                        </div>
                      )}
                    </div>

                    {avatar.image && <div className="card-modern-glow" />}

                    {/* ✅ بج آواتار فعلی */}
                    {isCurrent && avatar.image && (
                      <div className="card-selected-badge">✓</div>
                    )}

                    {/* ✅ بج خریداری‌شده (غیر از آواتار فعلی) */}
                    {isOwned && !isCurrent && avatar.image && (
                      <div className="card-owned-badge">🛒</div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {activeTab === "ai" && (
            <div className="ai-modern">
              <div className="ai-card-modern">
                <div className="ai-sparkle">✦</div>
                <h3>ساخت با هوش مصنوعی</h3>
                <p>به زودی ...</p>
                <div className="ai-wave">
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <footer className="avatar-footer-modern">
        <span>✨ هر آواتار یک داستان است ✨</span>
        <span className="footer-dot">•</span>
        <span className="footer-version">نسخه ۲.۰</span>
      </footer>
    </div>
  );
}